var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgConfirmIcon = function SvgConfirmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v34H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDEBF2",
    cx: 18,
    cy: 17,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6c6.075 0 11 4.925 11 11s-4.925 11-11 11S7 23.075 7 17 11.925 6 18 6zm0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm-.425 13c.207 0 .403.04.59.12.187.08.347.187.48.32s.24.293.32.48c.08.187.12.383.12.59 0 .213-.04.412-.12.595a1.448 1.448 0 0 1-.8.79 1.538 1.538 0 0 1-.59.115 1.564 1.564 0 0 1-1.085-.43 1.422 1.422 0 0 1-.32-.475 1.527 1.527 0 0 1-.115-.595c0-.207.038-.403.115-.59a1.41 1.41 0 0 1 .32-.48c.137-.133.298-.24.485-.32.187-.08.387-.12.6-.12zm.42-11c.58 0 1.108.08 1.585.24.477.16.885.388 1.225.685.34.297.603.655.79 1.075.187.42.28.89.28 1.41 0 .507-.073.945-.22 1.315-.147.37-.332.692-.555.965a4.41 4.41 0 0 1-.725.71l-.74.565c-.233.177-.435.35-.605.52-.17.17-.272.362-.305.575l-.23 1.46h-1.69l-.17-1.63a.445.445 0 0 1-.01-.085v-.085c0-.293.073-.548.22-.765.147-.217.33-.42.55-.61.22-.19.457-.375.71-.555a6.4 6.4 0 0 0 .71-.585c.22-.21.403-.448.55-.715.147-.267.22-.58.22-.94 0-.24-.045-.455-.135-.645a1.459 1.459 0 0 0-.375-.49 1.681 1.681 0 0 0-.575-.315 2.311 2.311 0 0 0-.725-.11c-.38 0-.702.042-.965.125a3.558 3.558 0 0 0-.67.28l-.174.1-.291.18a.64.64 0 0 1-.34.125c-.206 0-.362-.073-.47-.22l-.7-1.11c.227-.2.475-.39.745-.57a5.348 5.348 0 0 1 1.895-.785 5.814 5.814 0 0 1 1.19-.115z",
    fill: "#0481A0"
  }))));
};

export default SvgConfirmIcon;